var MDB = window.MDB || {};
MDB.GDPR = MDB.GDPR || {};
MDB.GDPR.Roi = MDB.GDPR.Roi || {};

MDB.GDPR.Roi.ListTable = function() {
    $('.dataTable').DataTable();
};

MDB.GDPR.Roi.Create = function (config) {
    var button = $('#uploadButton');
    var upload = $('#File');
    var label = $('#lblFileName');
    var numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    button.click(function (e) {
        e.preventDefault();
        clickFile();
    });

    upload.change(function (e) {
        var uploadValue = upload.val();
        var name = uploadValue.includes("\\")
            ? uploadValue.substring(uploadValue.lastIndexOf("\\") + 1)
            : uploadValue;


        label.html(config.labelTxt + ": " + name);

        label.show();
    });

    $('#Birthdate').keyup(function (e) {
        var value = e.target.value;

        if (value.length === 2 || value.length === 5) {
            e.target.value = value + "-";
        }
        if (!numbers.includes(e.key) || value.length === 11) {
            e.target.value = value.substring(0, value.length - 1);
        }

        if (e.keyCode === 8 && value.substring(value.length - 1) === "-") {
            e.target.value = value.substring(0, value.length - 2);
        }
    });

    $('#HouseNo').keyup(function (e) {
        var value = e.target.value;

        if (!numbers.includes(e.key)) {
            e.target.value = value.substring(0, value.length - 1);
        }
    });

    $('#Gender').change(function (e) {
        var value = e.target.value;

        if (value === "U") {
            $('#different').show();
        } else {
            $('#different').hide();
        }
    });


    function clickFile() {
        upload.click();
    }
};

MDB.GDPR.Roi.ProcessRequest = function (config) {

    var upload = $('#upload');
    var uploadButton = $('#uploadButton');
    var viewId = $('#viewId');
    var approve = $('#approve');
    var deny = $('#deny');
    var reviewData = $('#reviewData');
    var notify = $('#notify');

    var viewFirstTxt = $('#viewFirstTxt');
    var approveFirstTxt = $('#approveFirstTxt');

    if (config.approved === "False") {
        disableControls([approve, uploadButton]);
        viewFirstTxt.show();
        approveFirstTxt.show();
    } else {
        enableControls([uploadButton]);
    }

    if (config.denied === "False") {
        disableControls([deny]);
    }

    if (config.denied !== "True" && config.approved !== "True") {
        disableControls([notify]);
    }

    bindPromptButtons($('.requires-confirm'));

    uploadButton.click(function (e) {
        e.preventDefault();
        upload.click();
    });

    upload.change(function (e) {
        $('#submit').click();
    });

    if (config.hasUserData === "False") {
        disableControls([reviewData]);
    }

    viewId.click(function (e) {
        enableControls([approve, deny]);
        viewFirstTxt.hide();
    });


    function disableControls(controls) {
        controls.forEach(function (control) {
            control.prop('disabled', true);
        });
    }

    function enableControls(controls) {
        controls.forEach(function (control) {
            control.prop('disabled', false);
        });
    }

    function bindPromptButtons(selector) {
        $(selector).on('click',
            function (e) {
                e.preventDefault();
                var me = this;
                var $me = $(me);
                console.log(me);
                console.log($me);
                MDB.navigateAfterPrompt({
                    title: $me.data('title'),
                    textBody: $me.data('body'),
                    url: $me.data('url')
                });
            });
    }
};
